export const REFERENCE_NUMBER = "رقم الحوالة البنكية";

export const EDIT_DELIVERY_PERIOD = "تحرير فترة التسليم";
export const EDIT_INSPECTION_PERIOD = "تحرير فترة التفتيش";
export const EXTENDED_DELIVERY_TIME = "تمديد وقت الشحن";
export const ENTER_DELIVERY_VALUE =
  "أدخل العلم الذي تريد إضافته لفترة الشحن الحالية";
export const EXTENDED_INSPECTION_TIME = "تمديد وقت الفحص";
export const ENTER_INSPECTION_PERIOD =
  "أدخل العلامة التي تريد إضافتها لفترة الفحص الحالية";

export const PRODUCT_SERVICE = "تفاصيل المنتج / الخدمة";
export const HIDE_LINK = "عرض التفاصيل الإضافية";
export const DELETE_CONTRACT = "حذف العقد";
export const BTN_HAVE_PROBLEM = "هل تواجه مشكلة؟";
export const MODAL_ESCALATION_TITLE = "ما هي المشاكل التي تواجهك؟";
export const ACCEPT_PAYMENT = "قبول عملية الدفع";
export const REJECT_PAYMENT = "رفض";
export const PAYMENT_DETAILS = "تفاصيل الدفع";
export const PAYMENT_PROOF_ATTACHMENT = "مرفقات إثبات الدفع";
export const THE_BUYER = "المشتري";
export const THE_SELLER = "البائع";
export const TRANSFER_TO_SELLER = "تحويل للبائع";
export const TRANSFER_TO_BUYER = "تحويل للمشتري";

export const EXTENDED_SHIPPING_TIME = "تمديد الشحن";
export const ENTER_THE_SHIPPING_PERIOD =
  "أدخل عدد الايام  التي ترغب بإضافتها لمدة الشحن الحالية";

export const ADDITIONAL_PERIOD = "فترة إضافية";
export const TO_BE_SURE = "تأكيد";
